<template>
    <div class="navigation vertical-container vertical-container--in-secondary-side">
        <div class="vertical-container__header">
            <div class="navigation-title test__header">Rozšíření</div>
        </div>

        <div class="vertical-container__content">
            <ul class="navigation-list test__content">
                <li class="navigation-list__item">
                    <router-link :to="{ name: 'project-extension-catalogue'}" class="navigation-list__link">
                        Katalog jednotek
                    </router-link>
                </li>
                <li class="navigation-list__item">
                    <router-link :to="{ name: 'extension-newsletter'}" class="navigation-list__link">
                        Newsletter
                    </router-link>
                </li>
                <li class="navigation-list__item">
                    <router-link :to="{ name: 'extension-interest'}" class="navigation-list__link">
                        Zájemci
                    </router-link>
                </li>
            </ul>
            <div class="navigation-subtitle">Widgety</div>
            <ul class="navigation-list test__content">
                <li class="navigation-list__item">
                    <router-link :to="{ name: 'extension-widget'}" class="navigation-list__link">
                        Seznam
                    </router-link>
                </li>
            </ul>
            <div class="navigation-subtitle">Dokumentace</div>
            <ul class="navigation-list test__content">
                <li class="navigation-list__item">
                    <a :href="$dmv.env.DOCS_DOMAIN + '/api'" target="_blank" ref="nofollow" class="navigation-list__link">
                        API
                    </a>
                </li>
                <li class="navigation-list__item">
                    <a :href="$dmv.env.DOCS_DOMAIN + '/client'" target="_blank" ref="nofollow"
                       class="navigation-list__link">
                        Widget
                    </a>
                </li>
            </ul>
            <div class="navigation-subtitle">Zabezpečení</div>
            <ul class="navigation-list test__content">
                <li class="navigation-list__item">
                    <router-link :to="{ name: 'project-token'}" class="navigation-list__link">
                        Autorizační kódy
                    </router-link>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
export default {
    name: 'ProjectExtensionNav',
}
</script>
